import { render, staticRenderFns } from "./DetectiveWorking.vue?vue&type=template&id=32fcec64&"
import script from "./DetectiveWorking.vue?vue&type=script&lang=js&"
export * from "./DetectiveWorking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports